import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Hero — asymmetric copy + product-preview layout.
 * Mobile-first: the preview stacks below the copy (no content is hidden on
 * phones, where most Ghanaian traffic lands). Honest trust signals only.
 */
export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero-bg" aria-hidden="true">
        <span className="hero-glow hero-glow--gold" />
        <span className="hero-glow hero-glow--cyan" />
        <span className="hero-grid" />
      </div>

      <div className="hero-inner">
        {/* ── Copy ── */}
        <div className="hero-copy">
          <div className="hero-badge">
            <span className="hero-badge-dot" />
            {t('hero.kicker')}
          </div>

          <h1 id="hero-title">
            Healthcare for <span className="accent">every Ghanaian</span>.
          </h1>

          <p className="hero-sub">{t('hero.subtitle')}</p>

          <div className="hero-ctas">
            <Link to="/register" className="btn btn-primary btn-lg">
              {t('hero.ctaPrimary')}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
            <Link to="/register?role=clinician" className="btn btn-outline-white btn-lg">
              {t('hero.ctaSecondary')}
            </Link>
          </div>

          <ul className="hero-trust" aria-label="What you can rely on">
            <li><span className="ht-ico">✓</span> NHIS integrated</li>
            <li><span className="ht-ico">🏥</span> MDC-verified doctors</li>
            <li><span className="ht-ico">🔒</span> Bank-grade encryption</li>
            <li><span className="ht-ico">📍</span> All 16 regions</li>
          </ul>
        </div>

        {/* ── Product preview ── */}
        <div className="hero-preview" aria-hidden="true">
          <div className="hp-card hp-card--main">
            <div className="hp-head">
              <div className="hp-avatar">AA</div>
              <div className="hp-head-text">
                <div className="hp-name">Dr. Ama Asante</div>
                <div className="hp-meta"><span className="hp-dot" />Available now · General Practitioner</div>
              </div>
            </div>
            <div className="hp-chips">
              <span className="hp-chip">★ 4.9</span>
              <span className="hp-chip">Twi · English</span>
              <span className="hp-chip hp-chip--nhis">NHIS</span>
            </div>
            <div className="hp-cta">Book video consultation →</div>
          </div>

          <div className="hp-float hp-float--vitals">
            <div className="hp-label">Today's vitals</div>
            <div className="hp-value">120/80 <span className="hp-pill">Normal</span></div>
          </div>

          <div className="hp-float hp-float--nhis">
            <div className="hp-label">NHIS card</div>
            <div className="hp-value hp-value--ok">✓ Active</div>
            <div className="hp-sub">Verified in real time</div>
          </div>

          <div className="hp-float hp-float--rx">
            <div className="hp-label">Prescription</div>
            <div className="hp-value">Sent to pharmacy</div>
            <div className="hp-sub">Delivered to your door</div>
          </div>
        </div>
      </div>
    </section>
  );
}
